define('resolver',[], function () {
    return function (dependencies) {
        return {
            resolver: ['$q', '$rootScope', '$log', 'TrackingService', function ($q, $rootScope, $log, TrackingService) {
                var deferred = $q.defer();
                require(dependencies, function (args) {
                    $rootScope.$apply(function () {
                        deferred.resolve();
                    });
                }, function(error) {}
                );
                return deferred.promise;
            }]
        };
    }
});

